<script>
	export let options = [];
	export let value = null;
</script>

<div class="buttons">
	{#each options as o}
		{@const active = o.value === value}
		<div
			class="button"
			class:active
			style:color={!active ? o.color : null}
			on:click={() => {
				value = o.value;
			}}
		>
			<slot option={o} active={o.value === value} />
		</div>
	{/each}
</div>

<style lang="scss">
	@import "../main.scss";
	$btn-black: #1f1f1f;

	.buttons {
		text-align: center;
		display: flex;
		flex-direction: row;
		text-align: center;
		overflow: hidden;
		width: fit-content;
		font-weight: $medium;

		@media (max-width: $breakpoint-mobile-l) {
			width: 100%;
		}
	}

	.button {
		border: 1px solid $darkgrey;
		position: relative;
		white-space: nowrap;
		user-select: none;
		-webkit-tap-highlight-color: transparent;
		cursor: pointer;
		transition: background-color 0.3s ease, color 0.3s ease;
		padding: 9px 16px;
		color: $darkgrey;
		flex-grow: 1;

		@media (max-width: $breakpoint-mobile-m) {
			padding: 9px 0px;
		}

		&:not(:last-child) {
			margin-right: -1px;
		}
	}

	.button.active {
		pointer-events: none;
		font-weight: $medium;
		color: $white;
		background-color: $btn-black;
		// border-color: $btn-black;
	}
</style>
